import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
// Our Components
import { HeaderTableCell } from 'components/TransactionsSection/table/HeaderTableCell';
// Utils and Helpers
import { formatDate } from 'helpers/formatDate';
import { numberFormat } from 'helpers/i18n';
// Assets
import './ChildAchTransactionsTable.css';

const TableColumns = [
    {
        id: 'date',
        label: 'DATE',
        minWidth: 200,
        align: 'center',
        format: value => value.toLocaleString('en-US')
    },
    { id: 'txnId', label: 'TXN ID', minWidth: 80, align: 'center' },
    {
        id: 'merchant',
        label: 'MERCHANT',
        minWidth: 200,
        align: 'right'
    },
    {
        id: 'card',
        label: 'CARD',
        minWidth: 200,
        align: 'right'
    },
    {
        id: 'amount',
        label: 'AMOUNT',
        minWidth: 200,
        align: 'center'
    }
];

function ChildAchTransactionsTable({
    cardTransactionsInACH,
    setIsAchCardTransactionDetailsOpen,
    setSelectedCardTransaction,
    achCardTransactionsRef
}) {
    const handleCardTransactionClick = cardTransactionID => {
        setSelectedCardTransaction(cardTransactionID);
        setIsAchCardTransactionDetailsOpen(true);
        achCardTransactionsRef.current = cardTransactionsInACH;
    };

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 1440 }}>
            <Table stickyHeader aria-label="sticky table" sx={{ border: 'none' }}>
                <TableHead>
                    <TableRow>
                        {TableColumns.map((column, index) => (
                            <HeaderTableCell value={column.label} key={column.label} index={index} />
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody sx={{ height: cardTransactionsInACH?.results?.length === 0 && '600px' }}>
                    {cardTransactionsInACH.results.map(cardTransaction => (
                        <TableRow key={cardTransaction.id} hover role="checkbox">
                            <TableCell className="child-ach-transactions-table__table-row-cell">
                                {formatDate(cardTransaction.created_at)}
                            </TableCell>
                            <TableCell className="child-ach-transactions-table__table-row-cell">
                                <Box
                                    sx={{ color: '#4ABDE9', cursor: 'pointer' }}
                                    onClick={() => handleCardTransactionClick(cardTransaction?.id)}>
                                    {cardTransaction.id}
                                </Box>
                            </TableCell>
                            <TableCell className="child-ach-transactions-table__table-row-cell">
                                {cardTransaction?.merchantName}
                            </TableCell>
                            <TableCell className="child-ach-transactions-table__table-row-cell">
                                *{cardTransaction.last4}
                            </TableCell>
                            <TableCell className="child-ach-transactions-table__table-row-cell">
                                <Box className="fw-bold">{numberFormat(cardTransaction.amount, 2, 2)}</Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default ChildAchTransactionsTable;
